<template lang="pug">
  .AboutUs
    top-title
    top-images
    insist
    company-profile
    how-are-we-doing
    //why-can-we-do-it
    papers
</template>

<script>
  import TopTitle from "@/components/topTitle";
  import BottomFooter from "@/components/bottomFooter";
  import TopImages from "@/views/AboutUs/TopImages/TopImages";
  import Insist from "@/views/AboutUs/Insist/Insist";
  import CompanyProfile from "@/views/AboutUs/CompanyProfile/CompanyProfile";
  import HowAreWeDoing from "@/views/AboutUs/HowAreWeDoing/HowAreWeDoing";
  import WhyCanWeDoIt from "@/views/AboutUs/WhyCanWeDoIt/WhyCanWeDoIt";
  import Papers from "@/views/AboutUs/Papers/Papers";
  export default {
    name: "AboutUs",
    components: {Papers, WhyCanWeDoIt, HowAreWeDoing, CompanyProfile, Insist, TopImages, BottomFooter, TopTitle},
  };
</script>

<style scoped lang="stylus">
  .AboutUs {
    width 100%
    background-color white
  }
</style>
